import request from '@/utils/request'

//通过字典id查询数据
export function getPmiDic(params) {
    return request({
        url: '/api/PmiDictionary/GetByTypeId',
        method: 'get',
        params
    })
}


//根据id来获取基地
export function GetTrainBase(params) {
    return request({
        url: '/api/TrainBase/Get',
        method: 'get',
        params
    })
}

// 获取基地全部列表
export function GetLoadTrainBase(params) {
    return request({
        url: '/api/TrainBase/LoadQT',
        method: 'get',
        params
    })
}

//根据id来获取获取基地设备详情
export function GetEquipment(params) {
    return request({
        url: '/api/TrainBase/GetEquipment',
        method: 'get',
        params
    })
}

//根据id来获取基地建筑详情
export function GetBuilderTrainBase(params) {
    return request({
        url: '/api/TrainBase/GetBuilder',
        method: 'get',
        params
    })
}

//根据id来获取获取基地场地详情
export function GetField(params) {
    return request({
        url: '/api/TrainBase/GetField',
        method: 'get',
        params
    })
}

//首页调训所有数据
export function getSearchList(params) {
    return request({
        url: '/api/TrainInfo/SearchList',
        method: 'get',
        params
    })
}

//获取最新调训
export function getNewList(params) {
    return request({
        url: '/api/TrainInfo/NewList',
        method: 'get',
        params
    })
}

//Id获取调训信息
export function getListById(params) {
    return request({
        url: '/api/TrainInfo/Get',
        method: 'get',
        params
    })
}

//获取培训班日程安排信息
export function getScheduleList(params) {
    return request({
        url: '/api/TrainSchedule/GetList',
        method: 'get',
        params
    })
}

//获取调训人员成绩
export function getUserList(params) {
    return request({
        url: '/api/TrainPeople/GetUserList',
        method: 'get',
        params
    })
}

//获取培训班最近报名人员
export function getLateUser(params) {
    return request({
        url: '/api/TrainPeople/GetLateUser',
        method: 'get',
        params
    })
}

//获取培训班最近报名人员
export function signUp(params) {
    return request({
        url: '/api/TrainPeople/SignUp',
        method: 'get',
        params
    })
}

//加载列表
export function getLoad(params) {
    return request({
        url: '/api/TrainInfo/LoadQT',
        method: 'get',
        params
    })
}
// 建筑设施列表
export function TrainBaseJzssLoad(params) {
    return request({
        url: '/api/TrainBaseJzss/Load',
        method: 'get',
        params
    })
}
//添加申请免训
export function addPass(data) {
    return request({
        url: '/api/TrainFree/Add',
        method: 'post',
        data
    })
}
//查询是否申请免训
export function getFree(params) {
    return request({
        url: '/api/TrainFree/GetFree',
        method: 'get',
        params
    })
}


// 物资列表
export function TrainBaseWzLoad(params) {
    return request({
        url: '/api/TrainBaseWz/Load',
        method: 'get',
        params
    })
}

//获取基地联系人
export function getLeader(params) {
    return request({
        url: '/api/TrainBase/GetLeader',
        method: 'get',
        params
    })
}

//使用情况
export function TrainBaseGetList(params) {
    return request({
        url: '/api/TrainBase/GetList',
        method: 'get',
        params
    })
}

export function getBaseInfo(params) {
    return request({
        url: '/api/TrainInfo/GetBaseInfo',
        method: 'get',
        params
    })
}
//获取单个培训班详细信息
export function getDetail(params) {
    return request({
        url: '/api/TrainInfo/GetDetail',
        method: 'get',
        params
    })
}

// 基地评论

export function TrainBaseTalkAdd(data) {
    return request({
        url: '/api/TrainBaseTalk/Add',
        method: 'post',
        data
    })
}
export function TrainBaseTalkDelete(params) {
    return request({
        url: '/api/TrainBaseTalk/Delete',
        method: 'get',
        params
    })
}
export function TrainBaseTalkLoad(params) {
    return request({
        url: '/api/TrainBaseTalk/Load',
        method: 'get',
        params
    })
}

// 基地预约

export function TrainBaseYyAdd(data) {
    return request({
        url: '/api/TrainBaseYy/Add',
        method: 'post',
        data
    })
}
export function TrainBaseYyDelete(params) {
    return request({
        url: '/api/TrainBaseYy/Delete',
        method: 'get',
        params
    })
}
export function TrainBaseYyLoad(params) {
    return request({
        url: '/api/TrainBaseYy/Load',
        method: 'get',
        params
    })
}
export function TrainBaseYyPass(params) {
    return request({
        url: '/api/TrainBaseYy/Pass',
        method: 'get',
        params
    })
}
export function getUserScoreList(params) {
    return request({
        url: '/api/TrainSubject/GetUserScoreList',
        method: 'get',
        params
    })
}

export function getColumnName(params) {
    return request({
        url: '/api/TrainSubject/ColumnName',
        method: 'get',
        params
    })
}


//获取考勤统计列表
export function getCheckWorkList(params) {
    return request({
        url: '/api/Center/GetMyKQList',
        method: 'get',
        params
    })
}


//发起考勤申诉
export function addAlarmFree(data) {
    return request({
        url: '/api/AlarmFree/Add',
        method: 'post',
        data
    })
}

//查询是否发起考勤申诉
export function getAlarmFree(params) {
    return request({
        url: '/api/AlarmFree/GetFree',
        method: 'get',
        params
    })
}

//查询训历科目
export function getSubjectApi(params) {
    return request({
        url: '/api/Center/GetTrainScore',
        method: 'get',
        params
    })
}

//获取训历详情
export function getTrainingInfoApi(params) {
    return request({
        url: '/api/PmiUser/GetDetail',
        method: 'get',
        params
    })
}

//获取免训列表
export function getExemptionTrainLoadApi(params) {
    return request({
        url: '/api/TrainFree/Load',
        method: 'get',
        params
    })
}

//获取免训申请表详情
export function getExemptionTrainInfoApi(params) {
    return request({
        url: '/api/TrainFree/GetDetail',
        method: 'get',
        params
    })
}

//获取审核流程列表
export function getFlowApi(params) {
    return request({
        url: '/api/TrainFree/GetFlow',
        method: 'get',
        params
    })
}


//判断是否报名
export function isSignUpApi(params) {
    return request({
        url: '/api/TrainPeople/IsSignUp',
        method: 'get',
        params
    })
}

//取消报名
export function delSignUpApi(params) {
    return request({
        url: '/api/TrainPeople/DelSignUp',
        method: 'get',
        params
    })
}
